<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Pointages Remontés</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Matricule (" + error.datas.userId + ") - Date de pointage (" +
                    datefull(error.datas.dateTrackingFull) + ") - " + error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :disabled="disableMainBtn" :items="selectDates" @change="depthDate" dense
                        filled
                        full-width
                        hide-details="true"
                        item-text="name" item-value="value" return-object solo
                        style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span> Export modèle </span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export pointages</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="initdatetime()" block
                         class="custom-btn white--text"
                         color="#009688"
                         height="45px" large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Nouveau pointage</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier excel</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <!-- Message d'avertissement pour les brigades restreintes -->
                        <v-alert
                          v-if="!canCreatePointage && editedItem.userId"
                          border="left"
                          colored-border
                          type="warning"
                          class="mb-4"
                        >
                          <strong>Pointage manuel restreint</strong><br>
                          <span v-if="userRole !== 'ADMINISTRATOR' && userBrigade !== 'DIRECTION'">
                            <span v-if="editedItem.isTargetRestricted && ['MFD', 'ANF', 'RAL', 'CADRE'].some(keyword => userBrigade.includes(keyword))">
                              Seule la DIRECTION peut pointer pour ce matricule.
                            </span>
                            <span v-else-if="!['MFD', 'ANF', 'RAL', 'CADRE'].some(keyword => userBrigade.includes(keyword))">
                              Votre brigade n'est pas autorisée à effectuer des pointages manuels. 
                              Seules la DIRECTION et les Assistantes peuvent effectuer cette action.
                            </span>
                          </span>
                        </v-alert>
                        
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col md="6" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Matricule"
                                            prepend-inner-icon="mdi-human-male"
                                            v-model="editedItem.userId">

                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6" sm="6">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date pointage"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu= false"
                                    locale="fr-FR"
                                    v-model="editedItem.dateTracking"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-dialog
                                  :return-value.sync="editedItem.timeTracking"
                                  persistent
                                  ref="dialog"
                                  v-model="modal"
                                  width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Heure pointage"
                                                prepend-inner-icon="access_time"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedTimeFormatted"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    :useSeconds=true
                                    format="24hr"
                                    full-width
                                    v-if="modal"
                                    v-model="editedItem.timeTracking"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn @click="modal = false" color="primary" text>
                                    Annuler
                                  </v-btn>
                                  <v-btn @click="$refs.dialog.save(editedItem.timeTracking)"
                                         color="primary"
                                         text>
                                    Valider
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="12" sm="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B" label="Observations"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            rows="1"
                                            textarea
                                            v-model="editedItem.observations"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer pointage
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:red;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTable"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";

import apiClient from "../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../helper/profondeur";
import * as XLSX from 'xlsx';
import Vue from "vue";

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "pointages",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      modal: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      editedItem: {
        userId: "",
        targetBrigade: "", // Brigade de l'utilisateur cible pour validation
        isTargetRestricted: false, // Indique si l'utilisateur cible est dans une brigade restreinte
        dateTrackingFull: "",
        dateTracking: new Date().toISOString().substr(0, 10),
        timeTracking: moment(new Date()).format("HH:mm:ss"),
        observations: "",
      },
      restrictedUsers: [], // Liste des matricules dans les brigades restreintes
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      brigadetypes: [],
      absencetypes: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        trimRows: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Nom", "Prénom", "Brigade", "Date",
          "Heure", "Observations", "Num de série", "Origine",
          "Date création", "Matricule créateur"
        ],
        columns: [
          {title: "Id", width: "80px"},
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px"},
          {title: "Prénom", width: "200px"},
          {title: "Brigade", width: "160px"},
          {title: "Date", width: "180px", dateFormat: "DD-MM-YYYY", correctFormat: true, type: "date"},
          {title: "Heure", width: "180px", timeFormat: "HH:mm:ss", correctFormat: true, type: "time"},
          {title: "Observations", width: "180px", readOnly: false},
          {title: "Num de série", width: "160px"},
          {title: "Origine", width: "100px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px"}
        ]
      }
    }
  },
  created() {
    this.getData(this.depthVal)
    this.loadRestrictedUsers()
  },
  
  watch: {
    'editedItem.userId': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchTargetUserBrigade();
      }
    }
  },

  computed: {
    userBrigade() {
      return this.$store.getters.user?.brigade || sessionStorage.getItem('brigade') || '';
    },
    
    userRole() {
      return this.$store.getters.user?.role || sessionStorage.getItem('userRole') || '';
    },

    canCreatePointage() {
      const currentBrigade = this.userBrigade;
      const currentRole = this.userRole;
      
      // ADMINISTRATOR et la brigade DIRECTION peuvent créer des pointages pour tout le monde
      if (currentRole === 'ADMINISTRATOR' || currentBrigade === 'DIRECTION') {
        return true;
      }
      
      // Les brigades restreintes peuvent créer des pointages pour les non-restreintes
      const restrictedBrigades = ['MFD', 'ANF', 'RAL', 'CADRE'];
      const isCurrentRestricted = restrictedBrigades.some(keyword => currentBrigade.includes(keyword));
      
      if (isCurrentRestricted) {
        // Si on a un userId, on vérifie s'il est dans une brigade restreinte
        if (this.editedItem.userId) {
          // Les brigades restreintes NE peuvent PAS pointer pour les brigades restreintes (y compris elles-mêmes)
          return !this.editedItem.isTargetRestricted;
        }
        // Si pas encore de userId, on ne peut pas valider
        return false;
      }
      
      // Toutes les autres brigades ne peuvent pas créer de pointages manuels
      return false;
    },

    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.dateTracking !== "" &&
          this.editedItem.timeTracking !== "" &&
          this.editedItem.observations !== "" &&
          this.canCreatePointage
      );
    },

    computedDateFormatted() {
      return this.formatDate(this.editedItem.dateTracking)
    },

    computedTimeFormatted() {
      return this.editedItem.timeTracking
    },
  },

  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    initEditedItem() {
      this.editedItem.userId = "";
      this.editedItem.targetBrigade = "";
      this.editedItem.isTargetRestricted = false;
      this.editedItem.dateTrackingFull = "";
      this.editedItem.dateTracking = new Date().toISOString().substr(0, 10);
      this.editedItem.timeTracking = moment(new Date()).format("HH:mm:ss");
      this.editedItem.observations = "";
    },
    
    loadRestrictedUsers() {
      // Charger la liste des utilisateurs dans les brigades restreintes (MFD, ANF, RAL, CADRE)
      apiClient
        .get(`${this.$store.getters.user.baseUrl}/account/employees/restricted-brigades`)
        .then(response => {
          if (response.data && response.data.datas) {
            // Stocker les matricules des utilisateurs des brigades restreintes
            this.restrictedUsers = response.data.datas.map(user => user.userId);
          }
        })
        .catch(error => {
          console.error("Erreur lors du chargement des utilisateurs restreints:", error);
          this.restrictedUsers = [];
        });
    },
    
    fetchTargetUserBrigade() {
      if (!this.editedItem.userId) {
        this.editedItem.targetBrigade = "";
        this.editedItem.isTargetRestricted = false;
        return;
      }
      
      // Si l'utilisateur pointe pour lui-même
      const currentUserId = this.$store.getters.user?.userId || sessionStorage.getItem('userId');
      if (this.editedItem.userId === currentUserId) {
        this.editedItem.targetBrigade = this.userBrigade;
        // Vérifier si l'utilisateur actuel est dans une brigade restreinte
        const restrictedBrigades = ['MFD', 'ANF', 'RAL', 'CADRE'];
        this.editedItem.isTargetRestricted = restrictedBrigades.some(keyword => this.userBrigade.includes(keyword));
        return;
      }
      
      // Vérifier si le matricule est dans la liste des utilisateurs restreints (en mémoire)
      this.editedItem.isTargetRestricted = this.restrictedUsers.includes(this.editedItem.userId);
      
      // Pour l'affichage, on peut récupérer plus d'infos si nécessaire, mais ce n'est pas obligatoire
      // car on a déjà l'info importante : est-ce que l'utilisateur est restreint ou non
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    initdatetime() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.editedItem.dateTracking = new Date().toISOString().substr(0, 10);
      this.editedItem.timeTracking = moment(new Date()).format("HH:mm:ss");
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/timetracking/recordsbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                moment(item["dateTrackingFull"]).format("DD-MM-YYYY"),
                moment(item["dateTrackingFull"]).format("HH:mm:ss"),
                item["observations"],
                item["serialNumberCard"],
                item["typeRecord"],
                moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss"),
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du pointage.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              // Déterminer quelle colonne a été modifiée
              const columnIndex = changes[0][1];
              const isObservationEdit = columnIndex === 7; // Column "Observations" is at index 7

              let sdatetime = moment(obj[5] + " " + obj[6], "DD-MM-YYYY HH:mm:ss").format("YYYY-DD-MM HH:mm:ss")

              // Valider la date/heure seulement si ce n'est pas une modification de la colonne Observations
              if (!isObservationEdit && sdatetime === "Invalid date") {
                this.text = "Date & Heure invalide -> Ligne " + (changes[0][0] + 1) +
                    ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              newObj = {
                "id": obj[0],
                "userId": obj[1],
                "dateTrackingFull": sdatetime,
                "observations": obj[7]
              }
              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/timetracking/record/` +
                      sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')

                    this.initEditedItem();
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },

    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du pointage.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/timetracking/record/` +
                    rowId[0] +
                    "/" +
                    sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
          });
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    creer() {
      // Vérification supplémentaire des permissions
      if (!this.canCreatePointage) {
        const currentBrigade = this.userBrigade;
        const currentRole = this.userRole;
        const restrictedBrigades = ['MFD', 'ANF', 'RAL', 'CADRE'];
        
        let errorMessage = '';
        if (currentRole !== 'ADMINISTRATOR' && currentBrigade !== 'DIRECTION') {
          const isRestricted = restrictedBrigades.some(keyword => currentBrigade.includes(keyword));
          if (isRestricted && this.editedItem.isTargetRestricted) {
            errorMessage = `Les brigades ${restrictedBrigades.join(', ')} ne peuvent pas pointer entre elles. Seuls les ADMINISTRATOR et la brigade DIRECTION peuvent pointer pour ces brigades.`;
          } else if (!isRestricted) {
            errorMessage = 'Votre brigade n\'est pas autorisée à effectuer des pointages manuels. Seuls les ADMINISTRATOR, la brigade DIRECTION et les brigades spécifiques peuvent effectuer cette action.';
          }
        }
        
        this.alert = true;
        this.text = errorMessage;
        this.color = "#F44336";
        this.showAlert('warning');
        return;
      }

      this.loading = true
      this.editedItem.dateTrackingFull = this.editedItem.dateTracking + " " + this.editedItem.timeTracking
      this.editedItem.dateTracking = this.editedItem.timeTracking = ""

      const dataToSave = {
        userId: this.editedItem.userId,
        dateTrackingFull: moment(this.editedItem.dateTrackingFull).format("YYYY-MM-DD HH:mm:ss"),
        observations: this.editedItem.observations
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/timetracking/record/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            this.dialog = false;
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.initEditedItem();

              this.showAlert('info')
              this.depthDate();
              this.initEditedItem()
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.showAlert('warning')
            }
          })
          .catch(error => {
            this.alert = true
            this.text = error;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    importFileToHandsonTable() {
      let vm = this;
      vm.loading = true
      vm.dialog = false;
      this.file = ""
      let dataTosave = [];

      const fromExcelDate = require("js-excel-date-convert").fromExcelDate;

      for (let i = 0; i < this.excelData.length; i++) {
        let sdate = moment(fromExcelDate(this.excelData[i][1] + this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")

        if (sdate === "Invalid date") {
          this.text = "Date & Heure invalide -> Ligne " + (i + 2) +
              ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

          this.showAlert('warning')
          vm.loading = false
          return;
        }
      }

      for (let i = 0; i < this.excelData.length; i++) {
        dataTosave.push({
          userId: this.excelData[i][0],
          dateTrackingFull: moment(fromExcelDate(this.excelData[i][1] + this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss"),
          observations: this.excelData[i][3],
          originUser: sessionStorage.getItem("userId")
        });
      }
      apiClient
          .post(`${vm.$store.getters.user.baseUrl}/timetracking/records/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false

            if (res.data.status === 200) {
              let dataObj = [];
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Pointage(s) ajouté(s).";
                vm.file = "";
                this.showAlert('info')
                this.depthDate();
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.depthDate()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.depthDate()
              }
            }
          })
          .catch(err => {
            vm.loading = false
            vm.alert = true
            vm.text = err;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Pointages_remontés") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Pointages_remontés.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true

      var ws = XLSX.utils.json_to_sheet([
        {
          userId: "Matricule",
          date: "Date",
          Heure: "Heure",
          observations: "Observations"
        },
        {
          userId: "100",
          date: "26/12/30",
          Heure: "23:45:23",
          observations: "Retard du à la circulation"
        },
      ], {header: ["userId", "date", "Heure", "observations"], skipHeader: true, cellDates: true});

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Pointages_modèle") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Pointages_modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"
      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>
<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>

